export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://cssbuybr.mom';

export const SITE_NAME = 'CSSBuyBR';

export const SITE_IMAGE =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

export const LAST_MODIFIED = '2026-08-27';